module.exports = __webpack_public_path__ + "img/500.16ce59e.svg";